export default "__VITE_ASSET__CjCzIZUS__"